import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopProfileTop728x90Fs from './freestar/DesktopProfileTop728x90';
import DesktopProfileTop728x90Tab from './taboola/DesktopProfileTop728x90';
const DesktopProfileTop728x90 = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(DesktopProfileTop728x90Tab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopProfileTop728x90Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopProfileTop728x90.displayName = 'DesktopProfileTop728x90';
export default DesktopProfileTop728x90;
